module.exports = __webpack_public_path__ + "img/settings.dda0c089.svg";